import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Button } from "@similarweb/ui-components";

export const ModalContentWrapper = styled(FlexColumn)`
    width: 100%;
`;
ModalContentWrapper.displayName = "ModalContentWrapper";

export const ModalTitle = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const LabelTextWrapper = styled(FlexRow)`
    margin-top: 36px;
    align-items: center;
    padding-right: 8px;
`;
export const ModalLabelText = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const ModalLabelTextHint = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[250])};
`;

export const ModalButtonsWrapper = styled(FlexRow)<{
    isModalHintDisplayed: boolean;
}>`
    display: flex;
    justify-content: space-between;
    width: auto;
    margin: ${({ isModalHintDisplayed }) => (isModalHintDisplayed ? "32px 0 0 auto;" : "24px 0 0 auto;")};
`;

export const ModalDisclaimer = styled.div<{
    colorDisclaimer: boolean;
    isModalTextDisplayed: boolean;
    isModalHintDisplayed: boolean;
}>`
    padding-right: 8px;
    margin-top: ${({ isModalHintDisplayed, isModalTextDisplayed }) =>
        !isModalHintDisplayed && !isModalTextDisplayed
            ? "20px;"
            : !isModalHintDisplayed && isModalTextDisplayed
            ? "24px;"
            : "16px;"};
    ${({ colorDisclaimer }) =>
        colorDisclaimer
            ? setFontVariant("body2", colorsPalettes.carbon[400])
            : setFontVariant("caption", colorsPalettes.carbon[400])};
    ${({ colorDisclaimer }) =>
        colorDisclaimer
            ? `padding: 16px; 
            margin-right: 8px; 
            background-color: ${colorsPalettes.red[100]}; 
            border: 1px solid ${colorsPalettes.red[300]}; 
            border-radius: 4px;`
            : ""};
`;

export const BlackDot = styled.div`
    width: 3px;
    height: 3px;
    margin: 0 6px;
    background-color: ${colorsPalettes.carbon[500]};
    border-radius: 50%;
`;

export const StyledCancelButton = styled(Button)`
    margin-right: 4px;
`;
